<span 

  (mouseover)="toggleHover(true)" (mouseleave)="toggleHover(false)"
  [ngStyle]="{'border-color': label.group.color, 
    'background-color': (hoverable && isHover) ? 'rgba('+color.r+','+color.g+','+color.b+',0.3)' : 'transparent', 
    'bacopacity' : (hoverable && isHover) ? 0.3 : 1}"
  >{{label.name}}</span>
